<template>
  <div v-loading="loading">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bold; font-size: 16px;">搜索热词分析</span>
      </div>

      <!-- Filter & Export -->
      <div class="filter-container">
        <div class="filter-left">
          <template v-if="activeTab !== 'window_trend'">
            <span class="demonstration">全局时间范围：</span>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="windowDateRangePickerOptions"
              @change="onDateRangeChange"
            >
            </el-date-picker>
          </template>
          <span v-else class="demonstration">趋势查看使用预聚合固定窗口日均，无需选日期</span>
          <el-button type="primary" icon="el-icon-search" @click="fetchData" style="margin-left: 10px;" :disabled="tableLoading">查询</el-button>
          <el-button v-if="tableLoading" type="warning" icon="el-icon-close" @click="cancelFetchData()" style="margin-left: 10px;">取消查询</el-button>
          <span v-if="lastQueryTimingText" class="query-timing-text">{{ lastQueryTimingText }}</span>
        </div>
        <div class="filter-right">
           <el-button type="success" icon="el-icon-download" @click="exportData">导出数据</el-button>
        </div>
      </div>

      <!-- Tabs for different categories -->
      <el-tabs v-model="activeTab" @tab-click="handleTabClick" style="margin-top: 20px;">
        <el-tab-pane label="贴图查询" name="tietu_dialog"></el-tab-pane>
        <el-tab-pane label="模板查询" name="template_dialog"></el-tab-pane>
        <el-tab-pane label="主页模板查询" name="home_template"></el-tab-pane>
        <el-tab-pane label="总模板查询" name="all_template"></el-tab-pane>
        <el-tab-pane label="语音包查询" name="audio"></el-tab-pane>
        <el-tab-pane label="功能搜索查询" name="function_search"></el-tab-pane>
        <el-tab-pane label="新增热词" name="new_keywords"></el-tab-pane>
        <el-tab-pane label="趋势查看" name="window_trend"></el-tab-pane>
      </el-tabs>

      <!-- New Keywords Info Panel -->
      <div v-if="activeTab === 'new_keywords'" style="background-color: #f4f4f5; padding: 15px; margin-bottom: 20px; border-radius: 4px; border-left: 5px solid #909399;">
        <div style="font-weight: bold; margin-bottom: 10px; font-size: 16px;">新增热词分析参数说明</div>
        <div style="font-size: 14px; color: #606266;">
          <span style="margin-right: 20px;"><strong>历史观察期:</strong> {{ newKeywordsMeta.historyPeriod || '-' }}</span>
          <span style="margin-right: 20px;"><strong>最近观察期:</strong> {{ newKeywordsMeta.recentPeriod || '-' }}</span>
          <span style="margin-right: 20px; display: inline-flex; align-items: center;">
            <strong style="margin-right: 6px;">最低搜索量:</strong>
            <el-input-number
              v-model="minRecentNum"
              :min="1"
              :max="99999"
              :step="1"
              size="mini"
              controls-position="right"
              style="width: 120px;">
            </el-input-number>
            <span style="margin-left: 4px;">次</span>
          </span>
          <span style="display: inline-flex; align-items: center;">
            <strong style="margin-right: 6px;">增长倍数:</strong>
            <el-input-number
              v-model="minGrowthRate"
              :min="0.1"
              :max="999"
              :step="0.5"
              :precision="1"
              size="mini"
              controls-position="right"
              style="width: 120px;">
            </el-input-number>
            <span style="margin-left: 4px;">X</span>
          </span>
        </div>
        <div style="font-size: 16px; color: #F56C6C; margin-top: 8px; font-weight: 600;">
          如果搜索量很高，倍数低，也表示很重要
        </div>
      </div>

      <div v-if="activeTab === 'window_trend'" style="background-color: #f4f4f5; padding: 15px; margin-bottom: 20px; border-radius: 4px; border-left: 5px solid #409EFF;">
        <div style="font-weight: bold; margin-bottom: 8px; font-size: 16px;">趋势查看说明</div>
        <div style="font-size: 14px; color: #606266;">
          日均列以<strong>近28天</strong>为中间高度，往两边按相对高低画方块：比它高就更高，比它低就更矮。列头可排序，首次点击倒序；默认近14天日均倒序。
        </div>
      </div>

      <div class="analysis-content" v-loading="tableLoading">
        <!-- Visualization Chart -->
        <div id="chart" style="width: 100%; height: 400px; margin-top: 20px;"></div>

        <!-- Table Section -->
        <div style="margin-top: 30px;">
        <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
            <div style="display: flex; align-items: center;">
                <span style="font-size: 16px; font-weight: bold; margin-right: 15px;">详细数据列表</span>
                
                <!-- 新增热词：入口筛选 -->
                <el-select 
                    v-if="activeTab === 'new_keywords' || activeTab === 'window_trend'" 
                    v-model="entranceFilter" 
                    placeholder="入口筛选" 
                    size="small" 
                    style="width: 150px; margin-right: 10px;"
                    @change="fetchData"
                >
                    <el-option label="全部入口" value=""></el-option>
                    <el-option label="贴图" value="tietu_dialog"></el-option>
                    <el-option label="模板" value="template_dialog"></el-option>
                    <el-option label="主页模板" value="home_template"></el-option>
                    <el-option v-if="activeTab === 'window_trend'" label="总模板" value="all_template"></el-option>
                    <el-option label="语音包" value="audio"></el-option>
                    <el-option label="P图功能搜索" :value="FUNC_SEARCH_ENTRANCE"></el-option>
                    <el-option label="首页工具搜索" :value="TOOL_SEARCH_ENTRANCE"></el-option>
                </el-select>
                <!-- 功能搜索查询：子类别筛选 -->
                <el-select
                    v-if="activeTab === FUNCTION_SEARCH_TAB"
                    v-model="funcSearchEntranceFilter"
                    placeholder="类别筛选"
                    size="small"
                    style="width: 160px; margin-right: 10px;"
                    @change="fetchData"
                >
                    <el-option label="全部类别" value=""></el-option>
                    <el-option label="P图功能搜索" :value="FUNC_SEARCH_ENTRANCE"></el-option>
                    <el-option label="首页工具搜索" :value="TOOL_SEARCH_ENTRANCE"></el-option>
                </el-select>
            </div>

            <el-input
              v-model="searchQuery"
              placeholder="搜索关键词"
              style="width: 250px;"
              size="small"
              clearable
              prefix-icon="el-icon-search">
            </el-input>
            <template v-if="activeTab === 'new_keywords'">
              <el-button
                type="warning"
                size="small"
                style="margin-left: 10px;"
                :loading="materialCountBatchLoading[MATERIAL_COUNT_TYPE.TIETU]"
                @click="fetchMaterialCountsByType(MATERIAL_COUNT_TYPE.TIETU)">
                获取全部贴图数量
              </el-button>
              <el-button
                type="warning"
                size="small"
                style="margin-left: 10px;"
                :loading="materialCountBatchLoading[MATERIAL_COUNT_TYPE.TEMPLATE]"
                @click="fetchMaterialCountsByType(MATERIAL_COUNT_TYPE.TEMPLATE)">
                获取全部模板数量
              </el-button>
              <el-button
                type="warning"
                size="small"
                style="margin-left: 10px;"
                :loading="materialCountBatchLoading[MATERIAL_COUNT_TYPE.AUDIO]"
                @click="fetchMaterialCountsByType(MATERIAL_COUNT_TYPE.AUDIO)">
                获取全部语音包数量
              </el-button>
            </template>
            <el-button
              v-else-if="activeTab !== 'window_trend'"
              type="warning"
              size="small"
              style="margin-left: 10px;"
              :loading="materialCountLoading"
              @click="fetchMaterialCounts">
              获取全部素材数量
            </el-button>
        </div>

        <div ref="tableWrapper" class="table-wrapper">
        <el-table 
          :data="tableData" 
          class="analysis-table"
          :class="{ 'is-new-keywords': activeTab === 'new_keywords', 'is-window-trend': activeTab === 'window_trend' }"
          style="width:100%"
          border 
          stripe
          @sort-change="handleSortChange"
        >
          <el-table-column type="index" label="排名" :width="colWidths.rank" :index="indexMethod" align="center"></el-table-column>
          
          <!-- Common Columns -->
          <el-table-column
            v-if="activeTab === 'new_keywords'"
            prop="searchName"
            label="新增热词"
            :width="colWidths.search"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="search-name-text">{{ scope.row.searchName }}</span>
            </template>
          </el-table-column>
          <el-table-column v-else prop="searchName" label="搜索词" :width="colWidths.search" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="search-name-text">{{ scope.row.searchName }}</span>
            </template>
          </el-table-column>

          <!-- 趋势查看：日均方块高度以近28天为中间基准 -->
          <template v-if="activeTab === 'window_trend'">
            <el-table-column
              v-for="(col, colIndex) in windowTrendAvgColumns"
              :key="col.prop"
              :prop="col.prop"
              :label="col.label"
              :width="colWidths.avg"
              sortable="custom"
              :sort-orders="['descending', 'ascending', null]"
              align="center"
              class-name="trend-bar-col">
              <template slot-scope="scope">
                <div class="trend-bar-cell" :class="{ 'is-pivot': col.days === 28 }">
                  <div class="trend-bar-track">
                    <div class="trend-bar" :style="getTrendBarStyle(scope.row, colIndex)"></div>
                  </div>
                  <div class="trend-bar-num">{{ formatAvg(scope.row[col.prop]) }}</div>
                </div>
              </template>
            </el-table-column>
          </template>

          <el-table-column label="分析" :width="colWidths.action" align="center">
            <template slot-scope="scope">
              <div class="analysis-action-cell" :class="{ 'is-row': activeTab === 'new_keywords' }">
                <el-link type="primary" :underline="false" @click="openTrendDialog(scope.row)" class="quick-search-link">走势</el-link>
                <el-link type="primary" :underline="false" @click="openRelatedDialog(scope.row)" class="quick-search-link">相关词</el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeTab === 'new_keywords'"
            label="快捷搜索"
            :width="colWidths.quick"
            align="center">
            <template slot-scope="scope">
              <div class="quick-search-cell">
                <el-link type="primary" :underline="false" @click="quickSearch('internal', scope.row)" class="quick-search-link">站内</el-link>
                <el-link type="danger" :underline="false" @click="quickSearch('xiaohongshu', scope.row)" class="quick-search-link">小红书</el-link>
                <el-link type="info" :underline="false" @click="quickSearch('google', scope.row)" class="quick-search-link">谷歌</el-link>
                <el-link type="warning" :underline="false" @click="quickSearch('bilibili', scope.row)" class="quick-search-link">B站</el-link>
                <el-link type="danger" :underline="false" @click="quickSearch('douyin', scope.row)" class="quick-search-link">抖音</el-link>
                <el-link type="success" :underline="false" @click="quickSearch('kuaishou', scope.row)" class="quick-search-link">快手</el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else label="快捷搜索" :width="colWidths.quick" align="center">
            <template slot-scope="scope">
              <div class="quick-search-cell">
                <el-link type="primary" :underline="false" @click="quickSearch('internal', scope.row)" class="quick-search-link">站内</el-link>
                <el-link type="danger" :underline="false" @click="quickSearch('xiaohongshu', scope.row)" class="quick-search-link">小红书</el-link>
                <el-link type="info" :underline="false" @click="quickSearch('google', scope.row)" class="quick-search-link">谷歌</el-link>
                <el-link type="warning" :underline="false" @click="quickSearch('bilibili', scope.row)" class="quick-search-link">B站</el-link>
                <el-link type="danger" :underline="false" @click="quickSearch('douyin', scope.row)" class="quick-search-link">抖音</el-link>
                <el-link type="success" :underline="false" @click="quickSearch('kuaishou', scope.row)" class="quick-search-link">快手</el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeTab === 'new_keywords' && !entranceFilter"
            prop="entrancesLabel"
            label="入口类别"
            :width="colWidths.entrance"
            class-name="entrance-col"
            align="center">
            <template slot-scope="scope">
              <div class="entrance-label">{{ scope.row.entrancesLabel }}</div>
            </template>
          </el-table-column>
          
          <!-- Standard Columns -->
          <el-table-column v-if="activeTab !== 'new_keywords' && activeTab !== 'window_trend'" prop="totalNum" label="搜索次数" :width="colWidths.totalNum" sortable="custom" align="center"></el-table-column>
          <el-table-column v-if="activeTab !== 'new_keywords' && activeTab !== 'window_trend'" prop="percentile" label="累计占比 (%)" :width="colWidths.percentile" sortable="custom" align="center">
            <template slot-scope="scope">
              {{ scope.row.percentile ? parseFloat(scope.row.percentile).toFixed(2) : '0.00' }}%
            </template>
          </el-table-column>

          <!-- New Keywords Columns -->
          <el-table-column v-if="activeTab === 'new_keywords'" prop="recentNum" label="最近搜索量" :width="colWidths.recent" sortable="custom" align="center"></el-table-column>
          <el-table-column v-if="activeTab === 'new_keywords'" prop="historyNum" label="历史搜索量" :width="colWidths.history" sortable="custom" align="center"></el-table-column>
          <el-table-column v-if="activeTab === 'new_keywords'" prop="growthRate" label="增长率" :width="colWidths.growth" sortable="custom" align="center">
             <template slot-scope="scope">
                 <span :style="{ color: scope.row.growthRate === 'Inf' ? 'red' : 'inherit', fontWeight: scope.row.growthRate === 'Inf' ? 'bold' : 'normal' }">
                     {{ scope.row.growthRate }}
                 </span>
             </template>
          </el-table-column>
          <el-table-column v-if="activeTab === 'new_keywords'" prop="firstSeen" label="首次出现" :width="colWidths.firstSeen" sortable="custom" align="center"></el-table-column>
          <template v-if="activeTab === 'new_keywords'">
            <el-table-column label="贴图数量" :width="colWidths.material" align="center">
              <template slot-scope="scope">
                <div class="material-count-cell">
                  <template v-if="getMaterialCount(scope.row, MATERIAL_COUNT_TYPE.TIETU) !== undefined">
                    <div>{{ getMaterialCount(scope.row, MATERIAL_COUNT_TYPE.TIETU) }}</div>
                    <div class="material-ratio">{{ formatMaterialRatio(getMaterialCount(scope.row, MATERIAL_COUNT_TYPE.TIETU), getSearchCount(scope.row)) }}</div>
                  </template>
                  <el-button
                    v-else
                    type="primary"
                    size="mini"
                    plain
                    :loading="isMaterialCountLoading(scope.row, MATERIAL_COUNT_TYPE.TIETU)"
                    :disabled="materialCountBatchLoading[MATERIAL_COUNT_TYPE.TIETU]"
                    @click="fetchSingleMaterialCount(scope.row, MATERIAL_COUNT_TYPE.TIETU)">
                    获取
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="模板数量" :width="colWidths.material" align="center">
              <template slot-scope="scope">
                <div class="material-count-cell">
                  <template v-if="getMaterialCount(scope.row, MATERIAL_COUNT_TYPE.TEMPLATE) !== undefined">
                    <div>{{ getMaterialCount(scope.row, MATERIAL_COUNT_TYPE.TEMPLATE) }}</div>
                    <div class="material-ratio">{{ formatMaterialRatio(getMaterialCount(scope.row, MATERIAL_COUNT_TYPE.TEMPLATE), getSearchCount(scope.row)) }}</div>
                  </template>
                  <el-button
                    v-else
                    type="primary"
                    size="mini"
                    plain
                    :loading="isMaterialCountLoading(scope.row, MATERIAL_COUNT_TYPE.TEMPLATE)"
                    :disabled="materialCountBatchLoading[MATERIAL_COUNT_TYPE.TEMPLATE]"
                    @click="fetchSingleMaterialCount(scope.row, MATERIAL_COUNT_TYPE.TEMPLATE)">
                    获取
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="语音包数量" :width="colWidths.material" align="center">
              <template slot-scope="scope">
                <div class="material-count-cell">
                  <template v-if="getMaterialCount(scope.row, MATERIAL_COUNT_TYPE.AUDIO) !== undefined">
                    <div>{{ getMaterialCount(scope.row, MATERIAL_COUNT_TYPE.AUDIO) }}</div>
                    <div class="material-ratio">{{ formatMaterialRatio(getMaterialCount(scope.row, MATERIAL_COUNT_TYPE.AUDIO), getSearchCount(scope.row)) }}</div>
                  </template>
                  <el-button
                    v-else
                    type="primary"
                    size="mini"
                    plain
                    :loading="isMaterialCountLoading(scope.row, MATERIAL_COUNT_TYPE.AUDIO)"
                    :disabled="materialCountBatchLoading[MATERIAL_COUNT_TYPE.AUDIO]"
                    @click="fetchSingleMaterialCount(scope.row, MATERIAL_COUNT_TYPE.AUDIO)">
                    获取
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </template>
          <el-table-column v-else-if="activeTab !== 'window_trend'" :width="colWidths.material" label="素材数量" align="center">
            <template slot-scope="scope">
              <div class="material-count-cell">
                <template v-if="materialCountMap[scope.row.searchName] !== undefined">
                  <div>{{ materialCountMap[scope.row.searchName] }}</div>
                  <div class="material-ratio">{{ formatMaterialRatio(materialCountMap[scope.row.searchName], getSearchCount(scope.row)) }}</div>
                </template>
                <el-button
                  v-else
                  type="primary"
                  size="mini"
                  plain
                  :loading="materialCountRowLoadingMap[scope.row.searchName]"
                  :disabled="materialCountLoading"
                  @click="fetchSingleMaterialCountLegacy(scope.row)">
                  获取素材数量
                </el-button>
              </div>
            </template>
          </el-table-column>

        </el-table>
        </div>

          <!-- Pagination -->
          <div style="margin-top: 20px; text-align: right;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100, 300]"
                :page-size="pageSize"
                layout="sizes, prev, next, jumper"
                :total="total">
            </el-pagination>
          </div>
        </div>
      </div>

    </el-card>

    <el-dialog
      :title="trendDialogTitle"
      :visible.sync="trendDialogVisible"
      width="860px"
      append-to-body
      @closed="onTrendDialogClosed">
      <div class="trend-filter">
        <span>日期范围：</span>
        <el-date-picker
          v-model="trendDateRange"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :default-time="['00:00:00', '23:59:59']"
          :picker-options="dateRangePickerOptions"
          style="margin-right: 12px;">
        </el-date-picker>
        <span>粒度：</span>
        <el-input-number
          v-model="trendGranularityDays"
          :min="1"
          :max="30"
          size="small"
          style="width: 120px; margin-right: 4px;"
          @change="renderTrendChart">
        </el-input-number>
        <span style="margin-right: 12px;">天</span>
        <el-button type="primary" size="small" :loading="trendLoading" @click="fetchTrendData">查询</el-button>
      </div>
      <div v-loading="trendLoading" ref="trendChart" class="trend-chart"></div>
    </el-dialog>

    <el-dialog
      :title="relatedDialogTitle"
      :visible.sync="relatedDialogVisible"
      width="640px"
      append-to-body
      @closed="onRelatedDialogClosed">
      <div class="related-filter">
        <span>关键词：</span>
        <el-input
          v-model="relatedInputName"
          size="small"
          clearable
          placeholder="输入关键词后查询相关词"
          style="width: 220px; margin-right: 8px;"
          @keyup.enter.native="fetchRelatedWords">
        </el-input>
        <el-button type="primary" size="small" :loading="relatedLoading" @click="fetchRelatedWords">查询</el-button>
        <span style="margin-left: 16px;">时间范围：{{ relatedDateLabel }}</span>
        <span v-if="relatedList.length > 0" style="margin-left: 16px;">共 {{ relatedList.length }} 个相关词</span>
      </div>
      <div class="related-tip">
        说明：列出搜索词中包含「{{ relatedSearchName }}」的词（含本词），已按日期合并总搜索量并倒序排列；搜索次数 ≤ 2 的已过滤不展示。
      </div>
      <el-table
        v-loading="relatedLoading"
        :data="relatedList"
        border
        stripe
        max-height="480"
        style="width: 100%;">
        <el-table-column type="index" label="排名" width="70" align="center"></el-table-column>
        <el-table-column prop="searchName" label="搜索词" min-width="280" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.searchName }}</span>
            <el-tag
              v-if="scope.row.searchName === relatedSearchName"
              size="mini"
              type="success"
              style="margin-left: 8px;">
              本词
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="totalNum" label="搜索次数" width="120" align="center"></el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios';
import * as echarts from 'echarts';
import {dateRangePickerOptions} from '@/base_js/dateRangePickerOptions';

const AUDIO_PACK_PENDING_SEARCH_KEY = 'audioPackManagerSearchName';

const EXCLUDED_ENTRANCE_TYPES = ['emoticon', 'tietu_use_web_search'];

const INTERNAL_SEARCH_IMAGE_ENTRANCES = [
  'tietu_dialog',
  'template_dialog',
  'home_template',
  'all_template'
];
const INTERNAL_SEARCH_AUDIO_ENTRANCE = 'audio';

/** 与 NewSearchNameStatistics 对齐，勿随意改 */
const FUNC_SEARCH_ENTRANCE = 'func_search';
const TOOL_SEARCH_ENTRANCE = 'tool_search';
const FUNCTION_SEARCH_TAB = 'function_search';
const ALL_FUNCTION_SEARCH_TYPE = 'all_function_search';

const MATERIAL_COUNT_TYPE = {
  TIETU: 'tietu',
  TEMPLATE: 'template',
  AUDIO: 'audio'
};

const TREND_DEFAULT_GRANULARITY_DAYS = 1;
const TREND_MAX_RANGE_DAYS = 366;
const RELATED_PAGE_SIZE = 500;
/** 固定窗口（与后端预聚合对齐）；默认近 14 天 */
const QUERY_WINDOW_DAYS = [3, 7, 14, 28, 56, 112, 224];
const DEFAULT_DATE_RANGE_DAYS = 14;
const MS_PER_DAY = 3600 * 1000 * 24;
const WINDOW_DATE_RANGE_PICKER_OPTIONS = {
  shortcuts: [
    { text: '近3天', days: 3 },
    { text: '近7天（1周）', days: 7 },
    { text: '近14天（2周）', days: 14 },
    { text: '近28天（约1个月）', days: 28 },
    { text: '近56天（约2个月）', days: 56 },
    { text: '近112天（约4个月）', days: 112 },
    { text: '近224天（约7.5个月）', days: 224 }
  ].map(({ text, days }) => ({
    text,
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(end.getTime() - MS_PER_DAY * days);
      picker.$emit('pick', [start, end]);
    }
  }))
};
/** 新增热词默认入口：贴图（避免默认「全部入口」扫全量） */
const DEFAULT_NEW_KEYWORDS_ENTRANCE = 'tietu_dialog';
/** 趋势查看默认入口 */
const DEFAULT_WINDOW_TREND_ENTRANCE = 'tietu_dialog';
/** 趋势查看日均列（与预聚合 QUERY_WINDOW_DAYS 对齐，不含辅助窗 6） */
const WINDOW_TREND_AVG_COLUMNS = [
  { prop: 'avg3', label: '近3天日均', days: 3 },
  { prop: 'avg7', label: '近7天日均', days: 7 },
  { prop: 'avg14', label: '近14天日均', days: 14 },
  { prop: 'avg28', label: '近28天日均', days: 28 },
  { prop: 'avg56', label: '近56天日均', days: 56 },
  { prop: 'avg112', label: '近112天日均', days: 112 },
  { prop: 'avg224', label: '近224天日均', days: 224 }
];
/** 新增热词：最近观察期最低搜索量默认值 */
const DEFAULT_NEW_KEYWORDS_MIN_RECENT_NUM = 10;
/** 新增热词：增长倍数默认下限 */
const DEFAULT_NEW_KEYWORDS_MIN_GROWTH_RATE = 2;
/** 新增热词筛选本地缓存（下次打开沿用上次） */
const NEW_KEYWORDS_FILTER_CACHE_KEY = 'searchKeywordAnalysis_newKeywordsFilter';

function loadNewKeywordsFilterCache() {
  try {
    const raw = localStorage.getItem(NEW_KEYWORDS_FILTER_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch (e) {
    return null;
  }
}

function resolveCachedMinRecentNum() {
  const cached = loadNewKeywordsFilterCache();
  const n = cached && Number(cached.minRecentNum);
  return Number.isFinite(n) && n >= 1 ? Math.floor(n) : DEFAULT_NEW_KEYWORDS_MIN_RECENT_NUM;
}

function resolveCachedMinGrowthRate() {
  const cached = loadNewKeywordsFilterCache();
  const n = cached && Number(cached.minGrowthRate);
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_NEW_KEYWORDS_MIN_GROWTH_RATE;
}
const FETCH_IN_PROGRESS_TIP = '查询进行中，请先取消当前查询再操作';
const FETCH_CANCELLED_TIP = '已取消查询';

export default {
  name: 'SearchKeywordAnalysis',
  data() {
    return {
      FUNC_SEARCH_ENTRANCE,
      TOOL_SEARCH_ENTRANCE,
      FUNCTION_SEARCH_TAB,
      MATERIAL_COUNT_TYPE,
      dateRangePickerOptions,
      windowDateRangePickerOptions: WINDOW_DATE_RANGE_PICKER_OPTIONS,
      windowTrendAvgColumns: WINDOW_TREND_AVG_COLUMNS,
      loading: false,
      tableLoading: false,
      fetchCancelSource: null,
      firstSeenFetchSeq: 0,
      lastQueryTimingText: '',
      dateRange: [], 
      activeTab: 'tietu_dialog',
      tableData: [],
      chartInstance: null,
      
      // Pagination & Search & Sort
      searchQuery: '',
      currentPage: 1,
      pageSize: 300,
      total: 0,
      sortProp: 'totalNum',
      sortOrder: 'descending',
      
      // New Keywords Specific
      entranceFilter: DEFAULT_NEW_KEYWORDS_ENTRANCE,
      /** 功能搜索查询 Tab 子类别：空=全部，func_search / tool_search */
      funcSearchEntranceFilter: '',
      minRecentNum: resolveCachedMinRecentNum(),
      minGrowthRate: resolveCachedMinGrowthRate(),
      newKeywordsMeta: {},

      materialCountLoading: false,
      materialCountMap: {},
      materialCountRowLoadingMap: {},
      materialCountBatchLoading: {
        tietu: false,
        template: false,
        audio: false
      },
      tableLayoutWidth: 1200,

      trendDialogVisible: false,
      trendLoading: false,
      trendSearchName: '',
      trendType: '',
      trendDateRange: [],
      trendGranularityDays: TREND_DEFAULT_GRANULARITY_DAYS,
      trendChartInstance: null,
      trendRawData: [],

      relatedDialogVisible: false,
      relatedLoading: false,
      relatedInputName: '',
      relatedSearchName: '',
      relatedType: '',
      relatedList: [],
      relatedTotal: 0,
      relatedDateRange: [],

    };
  },
  computed: {
    trendDialogTitle() {
      return this.trendSearchName ? `「${this.trendSearchName}」搜索走势` : '搜索走势';
    },
    relatedDialogTitle() {
      return this.relatedSearchName ? `「${this.relatedSearchName}」相关词` : '相关词';
    },
    relatedDateLabel() {
      if (!this.relatedDateRange || this.relatedDateRange.length !== 2) {
        return '-';
      }
      return `${this.relatedDateRange[0]} 至 ${this.relatedDateRange[1]}`;
    },
    colWidths() {
      const w = Math.max(this.tableLayoutWidth || 1200, 900);
      if (this.activeTab === 'window_trend') {
        const fixed = {
          rank: 56,
          action: 118,
          avg: 118
        };
        const avgCols = WINDOW_TREND_AVG_COLUMNS.length;
        const used = fixed.rank + fixed.action + fixed.avg * avgCols;
        const remain = Math.max(w - used, 200);
        const flex = { search: 2.4, quick: 2.6 };
        const flexSum = flex.search + flex.quick;
        const flexSize = (part) => Math.max(1, Math.floor((remain * part) / flexSum));
        return {
          rank: fixed.rank,
          search: flexSize(flex.search),
          action: fixed.action,
          quick: flexSize(flex.quick),
          avg: fixed.avg,
          totalNum: 0,
          percentile: 0,
          entrance: 0,
          recent: 0,
          history: 0,
          growth: 0,
          firstSeen: 0,
          material: 0
        };
      }
      if (this.activeTab === 'new_keywords') {
        /**
         * 新增热词列宽规则（改之前先读完）：
         * 1. fixed 里是「内容决定宽度」的列，按内容够用即可，不要随便把中间某列拉得很宽。
         * 2. 入口类别（entrance）不重要，固定窄宽 + 两行换行显示；禁止再大幅加宽入口列。
         * 3. 剩余宽度只分给「新增热词(search)」和「快捷搜索(quick)」两列，不要塞给中间统计列。
         * 4. 需要调宽时：改对应 fixed 数值，或改下方 search/quick 的 flex 比例；不要用「给某列很大 weight」这种糊涂算法。
         */
        const hasEntrance = !this.entranceFilter;
        const fixed = {
          rank: 56,
          action: 118,
          // 入口：窄列 + 换行，不要加宽
          entrance: hasEntrance ? 165 : 0,
          recent: 150,
          history: 135,
          growth: 120,
          firstSeen: 180,
          material: 135
        };
        const materialCols = 3;
        const used = fixed.rank + fixed.action + fixed.entrance + fixed.recent + fixed.history
          + fixed.growth + fixed.firstSeen + fixed.material * materialCols;
        const remain = Math.max(w - used, 240);
        // 剩余宽度：新增热词 : 快捷搜索 = 2.88 : 3.12（热词相对原 2.4 份额 +20%，从快捷搜索匀出）
        const flex = { search: 2.88, quick: 3.12 };
        const flexSum = flex.search + flex.quick;
        const flexSize = (part) => Math.max(1, Math.floor((remain * part) / flexSum));
        return {
          rank: fixed.rank,
          search: flexSize(flex.search),
          action: fixed.action,
          quick: flexSize(flex.quick),
          entrance: fixed.entrance,
          recent: fixed.recent,
          history: fixed.history,
          growth: fixed.growth,
          firstSeen: fixed.firstSeen,
          material: fixed.material,
          totalNum: 0,
          percentile: 0,
          avg: 0
        };
      }
      return {
        rank: Math.max(70, Math.floor(w * 0.06)),
        search: Math.max(200, Math.floor(w * 0.22)),
        action: Math.max(100, Math.floor(w * 0.08)),
        quick: Math.max(220, Math.floor(w * 0.16)),
        totalNum: Math.max(120, Math.floor(w * 0.12)),
        percentile: Math.max(130, Math.floor(w * 0.13)),
        material: Math.max(200, Math.floor(w * 0.22)),
        entrance: 0,
        recent: 0,
        history: 0,
        growth: 0,
        firstSeen: 0,
        avg: 0
      };
    }
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
      // Debounce：取消进行中的查询再搜，避免「查询中」挡住关键词搜索
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.cancelFetchData(false);
        this.fetchData();
      }, 500);
    },
    // 最低搜索量 / 增长倍数：改完立刻写入本地，下次打开沿用
    minRecentNum() {
      this.saveNewKeywordsFilterCache();
    },
    minGrowthRate() {
      this.saveNewKeywordsFilterCache();
    }
  },
  mounted() {
    this.$bus.$emit("setMenuActiveIndex", "1-3-2");
    this.setDefaultDateRange();
    window.addEventListener('resize', this.handleResize);
    this.updateTableLayoutWidth();
    // 进页自动查（现在预聚合够快）
    this.fetchData();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.cancelFetchData(false);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
    if (this.trendChartInstance) {
      this.trendChartInstance.dispose();
    }
  },
  methods: {
    /** 缓存新增热词的最低搜索量、增长倍数，下次进页沿用 */
    saveNewKeywordsFilterCache() {
      try {
        localStorage.setItem(NEW_KEYWORDS_FILTER_CACHE_KEY, JSON.stringify({
          minRecentNum: this.minRecentNum,
          minGrowthRate: this.minGrowthRate
        }));
      } catch (e) {
        // 本地存储不可用时忽略，不影响查询
      }
    },
    cancelFetchData(showTip = true) {
      if (!this.fetchCancelSource) {
        return;
      }
      try {
        this.fetchCancelSource.cancel(FETCH_CANCELLED_TIP);
      } catch (e) {
        // ignore
      }
      this.fetchCancelSource = null;
      this.tableLoading = false;
      if (showTip) {
        this.$message.info(FETCH_CANCELLED_TIP);
      }
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
      if (this.trendChartInstance) {
        this.trendChartInstance.resize();
      }
      this.updateTableLayoutWidth();
    },
    resolveQueryType() {
      if (this.activeTab === 'new_keywords') {
        return this.entranceFilter;
      }
      if (this.activeTab === FUNCTION_SEARCH_TAB) {
        return this.funcSearchEntranceFilter || ALL_FUNCTION_SEARCH_TYPE;
      }
      return this.activeTab;
    },
    resolveTrendType() {
      if (this.activeTab === 'new_keywords' || this.activeTab === 'window_trend') {
        return this.entranceFilter || '';
      }
      if (this.activeTab === FUNCTION_SEARCH_TAB) {
        return this.funcSearchEntranceFilter || ALL_FUNCTION_SEARCH_TYPE;
      }
      return this.activeTab;
    },

    formatAvg(value) {
      if (value === null || value === undefined || value === '') {
        return '0.00';
      }
      const num = Number(value);
      if (Number.isNaN(num)) {
        return '0.00';
      }
      return num.toFixed(2);
    },

    /**
     * 趋势方块高度：近28天日均为中间高度（50%），
     * 其它窗口相对它按比例拉高/压矮，颜色统一蓝色。
     */
    getTrendBarStyle(row, colIndex) {
      const cols = WINDOW_TREND_AVG_COLUMNS;
      const pivotProp = cols.find(c => c.days === 28).prop;
      const pivotRaw = Number(row[pivotProp]);
      const pivotVal = Number.isFinite(pivotRaw) && pivotRaw > 0 ? pivotRaw : 0.01;
      const val = Number(row[cols[colIndex].prop]);
      const safeVal = Number.isFinite(val) && val > 0 ? val : 0;
      // 28天 = 50% 轨道高；2倍顶满 100%；过矮保底一点能看见
      let pct = (safeVal / pivotVal) * 50;
      if (pct > 100) pct = 100;
      if (pct < 6) pct = safeVal <= 0 ? 0 : 6;
      return { height: pct + '%' };
    },

    buildDefaultTrendDateRange() {
      const end = new Date();
      const start = new Date();
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 30);
      return [this.formatDate(start), this.formatDate(end)];
    },

    openTrendDialog(row) {
      this.trendSearchName = this.normalizeSearchName(row.searchName);
      this.trendType = this.resolveTrendType();
      if (!this.trendDateRange || this.trendDateRange.length !== 2) {
        this.trendDateRange = this.buildDefaultTrendDateRange();
      }
      if (!this.trendGranularityDays) {
        this.trendGranularityDays = TREND_DEFAULT_GRANULARITY_DAYS;
      }
      this.trendRawData = [];
      this.trendDialogVisible = true;
      this.$nextTick(() => {
        this.fetchTrendData();
      });
    },

    onTrendDialogClosed() {
      if (this.trendChartInstance) {
        this.trendChartInstance.dispose();
        this.trendChartInstance = null;
      }
      this.trendRawData = [];
    },

    async fetchTrendData() {
      if (!this.trendSearchName) {
        this.$message.warning('搜索词为空');
        return;
      }
      if (!this.trendDateRange || this.trendDateRange.length !== 2) {
        this.$message.warning('请选择时间范围');
        return;
      }
      const [startDate, endDate] = this.trendDateRange;
      const start = new Date(startDate);
      const end = new Date(endDate);
      const daySpan = Math.floor((end - start) / (24 * 3600 * 1000)) + 1;
      if (daySpan > TREND_MAX_RANGE_DAYS) {
        this.$message.warning(`时间范围不能超过${TREND_MAX_RANGE_DAYS}天`);
        return;
      }
      const granularity = Math.max(1, Number(this.trendGranularityDays) || TREND_DEFAULT_GRANULARITY_DAYS);
      this.trendGranularityDays = granularity;

      this.trendLoading = true;
      try {
        const res = await this.$request.post('/search/analysis/trend', {
          startDate,
          endDate,
          type: this.trendType,
          searchName: this.trendSearchName
        }, { timeout: 60000 });
        if (res.code !== 200) {
          this.$message.error(res.msg || '获取走势失败');
          return;
        }
        this.trendRawData = Array.isArray(res.data) ? res.data : [];
        this.$nextTick(() => {
          this.renderTrendChart();
        });
      } catch (error) {
        console.error(error);
        this.$message.error('获取走势失败');
      } finally {
        this.trendLoading = false;
      }
    },

    aggregateTrendByGranularity(rawData, granularityDays) {
      if (!this.trendDateRange || this.trendDateRange.length !== 2) {
        return { dates: [], values: [] };
      }
      const [rangeStart, rangeEnd] = this.trendDateRange;
      const countMap = {};
      (rawData || []).forEach(item => {
        const date = String(item.date || '').slice(0, 10);
        if (!date) {
          return;
        }
        countMap[date] = (countMap[date] || 0) + (Number(item.totalNum) || 0);
      });

      const start = new Date(rangeStart);
      const end = new Date(rangeEnd);
      const allDates = [];
      for (let cursor = new Date(start); cursor <= end; cursor.setDate(cursor.getDate() + 1)) {
        allDates.push(this.formatDate(cursor));
      }

      if (granularityDays <= 1) {
        return {
          dates: allDates,
          values: allDates.map(date => countMap[date] || 0)
        };
      }

      const dates = [];
      const values = [];
      for (let i = 0; i < allDates.length; i += granularityDays) {
        const chunk = allDates.slice(i, i + granularityDays);
        const startLabel = chunk[0];
        const endLabel = chunk[chunk.length - 1];
        dates.push(startLabel === endLabel ? startLabel : `${startLabel}~${endLabel}`);
        values.push(chunk.reduce((sum, date) => sum + (countMap[date] || 0), 0));
      }
      return { dates, values };
    },

    renderTrendChart() {
      const chartDom = this.$refs.trendChart;
      if (!chartDom) {
        return;
      }
      if (this.trendChartInstance) {
        this.trendChartInstance.dispose();
      }
      this.trendChartInstance = echarts.init(chartDom);
      const { dates, values } = this.aggregateTrendByGranularity(
        this.trendRawData,
        this.trendGranularityDays
      );
      this.trendChartInstance.setOption({
        title: {
          text: this.trendSearchName,
          left: 'center',
          textStyle: { fontSize: 14 }
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLabel: {
            rotate: dates.length > 15 ? 30 : 0
          }
        },
        yAxis: {
          type: 'value',
          name: '搜索次数',
          minInterval: 1
        },
        series: [{
          name: '搜索次数',
          type: 'line',
          smooth: true,
          data: values,
          areaStyle: {
            opacity: 0.08
          }
        }]
      });
    },

    openRelatedDialog(row) {
      const keyword = this.normalizeSearchName(row.searchName);
      this.relatedInputName = keyword;
      this.relatedSearchName = keyword;
      this.relatedType = this.resolveTrendType();
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning('请先选择时间范围');
        return;
      }
      this.relatedDateRange = [...this.dateRange];
      this.relatedList = [];
      this.relatedTotal = 0;
      this.relatedDialogVisible = true;
      this.$nextTick(() => {
        this.fetchRelatedWords();
      });
    },

    onRelatedDialogClosed() {
      this.relatedList = [];
      this.relatedTotal = 0;
      this.relatedInputName = '';
      this.relatedSearchName = '';
    },

    async fetchRelatedWords() {
      const keyword = this.normalizeSearchName(this.relatedInputName);
      if (!keyword) {
        this.$message.warning('请输入关键词');
        return;
      }
      if (!this.relatedDateRange || this.relatedDateRange.length !== 2) {
        this.$message.warning('请选择时间范围');
        return;
      }
      this.relatedSearchName = keyword;
      this.relatedInputName = keyword;
      const [startDate, endDate] = this.relatedDateRange;
      this.relatedLoading = true;
      try {
        const res = await this.$request.post('/search/analysis/keywords', {
          startDate,
          endDate,
          type: this.relatedType,
          page: 1,
          pageSize: RELATED_PAGE_SIZE,
          searchQuery: keyword,
          sortProp: 'totalNum',
          sortOrder: 'descending',
          minTotalNum: 3,
          // 固定窗命中则后端走预聚合；对不上自动慢查源表
          windowDays: this.resolveWindowDays(startDate, endDate)
        }, { timeout: 60000 });
        if (res.code !== 200) {
          this.$message.error(res.msg || '获取相关词失败');
          return;
        }
        let data = res.data;
        if (data && !Array.isArray(data) && Array.isArray(data.list)) {
          data = data.list;
        }
        const list = (Array.isArray(data) ? data : [])
          .filter(item => {
            const name = String(item.searchName || '');
            return name.includes(keyword) && (Number(item.totalNum) || 0) > 2;
          })
          .map(item => ({
            searchName: item.searchName,
            totalNum: Number(item.totalNum) || 0
          }))
          .sort((a, b) => b.totalNum - a.totalNum);
        this.relatedList = list;
        this.relatedTotal = list.length;
      } catch (error) {
        console.error(error);
        this.$message.error('获取相关词失败');
      } finally {
        this.relatedLoading = false;
      }
    },
    handleTabClick(tab) {
      this.searchQuery = '';
      this.currentPage = 1;
      this.funcSearchEntranceFilter = '';
      if (this.activeTab === 'new_keywords') {
        this.entranceFilter = DEFAULT_NEW_KEYWORDS_ENTRANCE;
        this.sortProp = 'recentNum';
      } else if (this.activeTab === 'window_trend') {
        this.entranceFilter = DEFAULT_WINDOW_TREND_ENTRANCE;
        this.sortProp = 'avg14';
        this.sortOrder = 'descending';
      } else {
        this.entranceFilter = '';
        this.sortProp = 'totalNum';
      }
      this.materialCountMap = {};
      this.materialCountRowLoadingMap = {};
      this.resetMaterialCountBatchLoading();
      this.tableData = [];
      this.total = 0;
      this.newKeywordsMeta = {};
      if (this.chartInstance) {
        this.chartInstance.clear();
      }
      this.updateTableLayoutWidth();
      // 切 Tab 自动查
      this.cancelFetchData(false);
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    /** 改日期/快捷窗口后自动查 */
    onDateRangeChange() {
      this.currentPage = 1;
      this.cancelFetchData(false);
      this.fetchData();
    },
    updateTableLayoutWidth() {
      this.$nextTick(() => {
        const wrapper = this.$refs.tableWrapper;
        if (wrapper && wrapper.clientWidth) {
          this.tableLayoutWidth = wrapper.clientWidth;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    handleSortChange({ prop, order }) {
      this.sortProp = prop;
      this.sortOrder = order;
      this.currentPage = 1;
      this.fetchData();
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    
    setDefaultDateRange() {
      const end = new Date();
      const start = new Date();
      start.setTime(end.getTime() - MS_PER_DAY * DEFAULT_DATE_RANGE_DAYS);
      this.dateRange = [this.formatDate(start), this.formatDate(end)];
    },

    /** 结束日为今天且跨度命中固定窗时返回 windowDays，否则 null（走慢查） */
    resolveWindowDays(startDate, endDate) {
      if (!startDate || !endDate) {
        return null;
      }
      const today = this.formatDate(new Date());
      if (endDate !== today) {
        return null;
      }
      const start = new Date(`${startDate}T00:00:00`);
      const end = new Date(`${endDate}T00:00:00`);
      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
        return null;
      }
      const days = Math.round((end.getTime() - start.getTime()) / MS_PER_DAY);
      return QUERY_WINDOW_DAYS.includes(days) ? days : null;
    },
    
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    
    formatDateTime(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }

      let date;
      if (value instanceof Date) {
        date = value;
      } else if (typeof value === 'number') {
        const ms = value < 1e12 ? value * 1000 : value;
        date = new Date(ms);
      } else if (typeof value === 'string') {
        const trimmed = value.trim();
        if (/^\d+$/.test(trimmed)) {
          const num = Number(trimmed);
          const ms = num < 1e12 ? num * 1000 : num;
          date = new Date(ms);
        } else {
          const normalized = trimmed.replace('T', ' ').replace('Z', '');
          date = new Date(normalized);
          if (Number.isNaN(date.getTime())) {
            date = new Date(trimmed);
          }
        }
      } else {
        return String(value);
      }

      if (Number.isNaN(date.getTime())) {
        return String(value);
      }

      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const hh = String(date.getHours()).padStart(2, '0');
      const mm = String(date.getMinutes()).padStart(2, '0');
      const ss = String(date.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },

    formatShortDateTime(value) {
      const full = this.formatDateTime(value);
      if (!full || full.length < 16) {
        return full;
      }
      return full.slice(5, 16);
    },

    resolveEntranceType(row) {
      if (this.activeTab !== 'new_keywords' && this.activeTab !== 'window_trend') {
        return this.activeTab;
      }
      if (this.entranceFilter) {
        return this.entranceFilter;
      }
      if (row.entrances) {
        return String(row.entrances).split(',')[0].trim();
      }
      return 'tietu_dialog';
    },

    getRowEntrances(row) {
      if (this.activeTab !== 'new_keywords' && this.activeTab !== 'window_trend') {
        return [this.activeTab];
      }
      if (this.entranceFilter) {
        return [this.entranceFilter];
      }
      if (!row.entrances) {
        return ['tietu_dialog'];
      }
      return String(row.entrances)
        .split(',')
        .map(item => item.trim())
        .filter(Boolean)
        .filter(item => !EXCLUDED_ENTRANCE_TYPES.includes(item));
    },

    resolveInternalSearchTarget(row) {
      if (this.activeTab === INTERNAL_SEARCH_AUDIO_ENTRANCE) {
        return 'audio';
      }
      if (this.activeTab !== 'new_keywords' && this.activeTab !== 'window_trend'
          && INTERNAL_SEARCH_IMAGE_ENTRANCES.includes(this.activeTab)) {
        return 'image';
      }
      if (this.entranceFilter === INTERNAL_SEARCH_AUDIO_ENTRANCE) {
        return 'audio';
      }
      if (this.entranceFilter && INTERNAL_SEARCH_IMAGE_ENTRANCES.includes(this.entranceFilter)) {
        return 'image';
      }
      const entrances = this.getRowEntrances(row);
      const hasImageEntrance = entrances.some(item => INTERNAL_SEARCH_IMAGE_ENTRANCES.includes(item));
      if (hasImageEntrance) {
        return 'image';
      }
      if (entrances.includes(INTERNAL_SEARCH_AUDIO_ENTRANCE)) {
        return 'audio';
      }
      return 'image';
    },

    normalizeSearchName(name) {
      return name == null ? '' : String(name).trim();
    },

    // 与 ImageManage.getImages 保持一致的搜索参数（全部素材 + 全部分类 + 严格匹配）
    async fetchImageMaterialCount(searchName) {
      const keyword = this.normalizeSearchName(searchName);
      if (!keyword) {
        return 0;
      }
      const params = new URLSearchParams();
      params.append('userId', 'baozouptu');
      params.append('isPage', 1);
      params.append('pageNo', 1);
      params.append('pageCount', 1);
      params.append('isShowCategory', '1');
      params.append('categoryId', 0);
      params.append('category', 'all');
      params.append('heatOrder', 0);
      params.append('timeOrder', 0);
      params.append('updateTimeOrder', 0);
      params.append('hasTemplateDataOrder', 0);
      params.append('hotnessOrder', 0);
      params.append('searchName', keyword);
      params.append('isStrictSearch', true);
      const res = await this.$request.post('/images/getImageList', params);
      return (res.data && res.data.total !== undefined) ? res.data.total : 0;
    },

    // 与 APP 端保持一致的搜索参数（不分页，走 getAudioPackList）
    async fetchAudioMaterialCount(searchName) {
      const keyword = this.normalizeSearchName(searchName);
      if (!keyword) {
        return 0;
      }
      const res = await this.$request.post('/audio/getAudioPackList', {
        isPage: 0,
        searchName: keyword
      });
      return Array.isArray(res.data) ? res.data.length : 0;
    },

    async fetchMaterialCountByType(searchName, countType) {
      if (countType === MATERIAL_COUNT_TYPE.AUDIO) {
        return this.fetchAudioMaterialCount(searchName);
      }
      if (countType === MATERIAL_COUNT_TYPE.TIETU) {
        return this.fetchImageMaterialCount(searchName);
      }
      if (countType === MATERIAL_COUNT_TYPE.TEMPLATE) {
        return this.fetchImageMaterialCount(searchName);
      }
      return 0;
    },

    getSearchCount(row) {
      if (this.activeTab === 'new_keywords') {
        return Number(row.recentNum) || 0;
      }
      return Number(row.totalNum) || 0;
    },

    formatMaterialRatio(materialCount, searchCount) {
      const search = Number(searchCount);
      if (!search) {
        return '数量比 -';
      }
      const ratio = Number(materialCount) / search;
      return `数量比 ${ratio.toFixed(3)}`;
    },

    getMaterialCount(row, countType) {
      const counts = this.materialCountMap[row.searchName];
      if (!counts) {
        return undefined;
      }
      return counts[countType];
    },

    isMaterialCountLoading(row, countType) {
      return !!this.materialCountRowLoadingMap[`${row.searchName}_${countType}`];
    },

    setMaterialCount(searchName, countType, count) {
      if (!this.materialCountMap[searchName]) {
        this.$set(this.materialCountMap, searchName, {});
      }
      this.$set(this.materialCountMap[searchName], countType, count);
    },

    async fetchMaterialCountForRow(row) {
      const entranceType = this.resolveEntranceType(row);
      if (entranceType === 'audio') {
        return this.fetchAudioMaterialCount(row.searchName);
      }
      return this.fetchImageMaterialCount(row.searchName);
    },

    async fetchSingleMaterialCount(row, countType) {
      const searchName = row.searchName;
      if (this.getMaterialCount(row, countType) !== undefined) {
        return;
      }
      const loadingKey = `${searchName}_${countType}`;
      this.$set(this.materialCountRowLoadingMap, loadingKey, true);
      try {
        const count = await this.fetchMaterialCountByType(searchName, countType);
        this.setMaterialCount(searchName, countType, count);
      } catch (error) {
        console.error('fetch material count failed:', searchName, countType, error);
        this.$message.error(`获取「${searchName}」素材数量失败`);
      } finally {
        this.$set(this.materialCountRowLoadingMap, loadingKey, false);
      }
    },

    async fetchAllMaterialCountsForRow(row) {
      const types = [
        MATERIAL_COUNT_TYPE.TIETU,
        MATERIAL_COUNT_TYPE.TEMPLATE,
        MATERIAL_COUNT_TYPE.AUDIO
      ];
      for (const countType of types) {
        if (this.getMaterialCount(row, countType) !== undefined) {
          continue;
        }
        const loadingKey = `${row.searchName}_${countType}`;
        this.$set(this.materialCountRowLoadingMap, loadingKey, true);
        try {
          const count = await this.fetchMaterialCountByType(row.searchName, countType);
          this.setMaterialCount(row.searchName, countType, count);
        } catch (error) {
          console.error('fetch material count failed:', row.searchName, countType, error);
        } finally {
          this.$set(this.materialCountRowLoadingMap, loadingKey, false);
        }
      }
    },

    async fetchSingleMaterialCountLegacy(row) {
      const searchName = row.searchName;
      if (this.materialCountMap[searchName] !== undefined) {
        return;
      }
      this.$set(this.materialCountRowLoadingMap, searchName, true);
      try {
        const count = await this.fetchMaterialCountForRow(row);
        this.$set(this.materialCountMap, searchName, count);
      } catch (error) {
        console.error('fetch material count failed:', searchName, error);
        this.$message.error(`获取「${searchName}」素材数量失败`);
      } finally {
        this.$set(this.materialCountRowLoadingMap, searchName, false);
      }
    },

    async fetchMaterialCountsByType(countType) {
      if (this.tableData.length === 0) {
        this.$message.warning('暂无数据');
        return;
      }
      const typeLabelMap = {
        [MATERIAL_COUNT_TYPE.TIETU]: '贴图',
        [MATERIAL_COUNT_TYPE.TEMPLATE]: '模板',
        [MATERIAL_COUNT_TYPE.AUDIO]: '语音包'
      };
      this.$set(this.materialCountBatchLoading, countType, true);
      let successCount = 0;
      try {
        for (const row of this.tableData) {
          if (this.getMaterialCount(row, countType) !== undefined) {
            continue;
          }
          const loadingKey = `${row.searchName}_${countType}`;
          this.$set(this.materialCountRowLoadingMap, loadingKey, true);
          try {
            const count = await this.fetchMaterialCountByType(row.searchName, countType);
            this.setMaterialCount(row.searchName, countType, count);
            successCount++;
          } catch (error) {
            console.error('fetch material count failed:', row.searchName, countType, error);
          } finally {
            this.$set(this.materialCountRowLoadingMap, loadingKey, false);
          }
        }
        this.$message.success(`${typeLabelMap[countType]}数量获取完成，共 ${successCount} 条`);
      } finally {
        this.$set(this.materialCountBatchLoading, countType, false);
      }
    },

    resetMaterialCountBatchLoading() {
      this.materialCountBatchLoading = {
        tietu: false,
        template: false,
        audio: false
      };
    },

    async fetchMaterialCounts() {
      if (this.tableData.length === 0) {
        this.$message.warning('暂无数据');
        return;
      }
      this.materialCountLoading = true;
      let successCount = 0;
      try {
        for (const row of this.tableData) {
          if (this.activeTab === 'new_keywords') {
            const before = [
              this.getMaterialCount(row, MATERIAL_COUNT_TYPE.TIETU),
              this.getMaterialCount(row, MATERIAL_COUNT_TYPE.TEMPLATE),
              this.getMaterialCount(row, MATERIAL_COUNT_TYPE.AUDIO)
            ].filter(item => item !== undefined).length;
            await this.fetchAllMaterialCountsForRow(row);
            const after = [
              this.getMaterialCount(row, MATERIAL_COUNT_TYPE.TIETU),
              this.getMaterialCount(row, MATERIAL_COUNT_TYPE.TEMPLATE),
              this.getMaterialCount(row, MATERIAL_COUNT_TYPE.AUDIO)
            ].filter(item => item !== undefined).length;
            if (after > before) {
              successCount++;
            }
            continue;
          }
          if (this.materialCountMap[row.searchName] !== undefined) {
            continue;
          }
          try {
            const count = await this.fetchMaterialCountForRow(row);
            this.$set(this.materialCountMap, row.searchName, count);
            successCount++;
          } catch (error) {
            console.error('fetch material count failed:', row.searchName, error);
          }
        }
        this.$message.success(`素材数量获取完成，共 ${successCount} 条`);
      } finally {
        this.materialCountLoading = false;
      }
    },

    quickSearch(platform, row) {
      const searchName = this.normalizeSearchName(row.searchName);
      const keyword = encodeURIComponent(searchName);
      if (platform === 'internal') {
        const target = this.resolveInternalSearchTarget(row);
        if (target === 'audio') {
          sessionStorage.setItem(AUDIO_PACK_PENDING_SEARCH_KEY, searchName);
          const routeUrl = this.$router.resolve({
            name: 'audioPackManager'
          });
          window.open(routeUrl.href, '_blank');
        } else {
          const routeUrl = this.$router.resolve({
            name: 'imageManage',
            query: { searchName, isStrictSearch: 'true' }
          });
          window.open(routeUrl.href, '_blank');
        }
      } else if (platform === 'xiaohongshu') {
        window.open(`https://www.xiaohongshu.com/search_result?keyword=${keyword}`, '_blank', 'noopener,noreferrer');
      } else if (platform === 'google') {
        window.open(`https://www.google.com/search?q=${keyword}`, '_blank', 'noopener,noreferrer');
      } else if (platform === 'bilibili') {
        window.open(`https://search.bilibili.com/all?keyword=${keyword}`, '_blank', 'noopener,noreferrer');
      } else if (platform === 'douyin') {
        window.open(`https://www.douyin.com/search/${keyword}`, '_blank', 'noopener,noreferrer');
      } else if (platform === 'kuaishou') {
        window.open(`https://www.kuaishou.com/search/${keyword}`, '_blank', 'noopener,noreferrer');
      }
    },

    formatEntranceLabels(value) {
      if (!value) {
        return '-';
      }
      const entranceLabelMap = {
        tietu_dialog: '贴图',
        template_dialog: '模板',
        home_template: '模板',
        audio: '语音包',
        all_template: '总模板',
        func_search: 'P图功能搜索',
        tool_search: '首页工具搜索',
        all_function_search: '功能搜索'
      };
      const labels = [];
      String(value)
        .split(',')
        .map(item => item.trim())
        .filter(Boolean)
        .filter(item => !EXCLUDED_ENTRANCE_TYPES.includes(item))
        .forEach(item => {
          const label = entranceLabelMap[item] || item;
          if (!labels.includes(label)) {
            labels.push(label);
          }
        });
      return labels.length ? labels.join('、') : '-';
    },

    /**
     * 列表先展示后，再请求首次出现并回填表格。
     * 用序号丢弃过期响应，避免连续查询时旧结果盖住新页。
     */
    async fillFirstSeenAsync(rows, meta, type) {
      if (!rows || !rows.length || !meta) {
        return;
      }
      const names = rows.map(r => r.searchName).filter(Boolean);
      if (!names.length) {
        return;
      }
      const seq = ++this.firstSeenFetchSeq;
      const startDate = meta.recentStartDateTime || (this.dateRange && this.dateRange[0]);
      const endDate = meta.recentEndDateTime || (this.dateRange && this.dateRange[1]);
      try {
        const res = await this.$request.post('/search/analysis/first_seen_batch', {
          startDate,
          endDate,
          type: type || '',
          searchNames: names
        }, { timeout: 120000 });
        if (seq !== this.firstSeenFetchSeq) {
          return;
        }
        if (!res || res.code !== 200 || !Array.isArray(res.data)) {
          return;
        }
        const map = {};
        res.data.forEach(item => {
          if (item && item.searchName != null && item.firstSeen != null) {
            map[item.searchName] = this.formatShortDateTime(item.firstSeen);
          }
        });
        const next = rows.map(row => ({
          ...row,
          firstSeen: map[row.searchName] != null ? map[row.searchName] : (row.firstSeen === '加载中…' ? '-' : row.firstSeen)
        }));
        this.tableData = Object.freeze(next);
      } catch (e) {
        if (seq !== this.firstSeenFetchSeq) {
          return;
        }
        console.error('补首次出现失败', e);
        const next = rows.map(row => ({
          ...row,
          firstSeen: row.firstSeen === '加载中…' ? '-' : row.firstSeen
        }));
        this.tableData = Object.freeze(next);
      }
    },

    async fetchData() {
      if (this.activeTab !== 'window_trend' && (!this.dateRange || this.dateRange.length !== 2)) {
        this.$message.warning('请选择时间范围');
        return;
      }
      if (this.tableLoading) {
        this.$message.warning(FETCH_IN_PROGRESS_TIP);
        return;
      }

      this.tableLoading = true;
      this.fetchCancelSource = axios.CancelToken.source();
      const cancelToken = this.fetchCancelSource.token;
      // 新查询开始即作废进行中的 firstSeen 回填
      this.firstSeenFetchSeq += 1;
      const [startDate, endDate] = this.dateRange || [];
      const type = this.activeTab;
      const queryType = this.resolveQueryType();
      const clientStartMs = performance.now();
      const windowDays = this.resolveWindowDays(startDate, endDate);
      
      try {
        let res;
        
        if (type === 'window_trend') {
             res = await this.$request.post('/search/analysis/window_trend', {
                type: this.entranceFilter,
                page: this.currentPage,
                pageSize: this.pageSize,
                searchQuery: this.searchQuery,
                sortProp: this.sortProp || 'avg14',
                sortOrder: this.sortOrder || 'descending'
             }, { timeout: 120000, cancelToken });
        } else if (type === 'new_keywords') {
             const newKeywordsType = this.entranceFilter; 
             console.log('Fetching new keywords with params:', { startDate, endDate, type: newKeywordsType, windowDays });
             res = await this.$request.post('/search/analysis/new_keywords', {
                startDate,
                endDate,
                type: newKeywordsType,
                page: this.currentPage,
                pageSize: this.pageSize,
                searchQuery: this.searchQuery,
                sortProp: this.sortProp,
                sortOrder: this.sortOrder,
                minRecentNum: this.minRecentNum,
                minGrowthRate: this.minGrowthRate,
                windowDays
             }, { timeout: 120000, cancelToken });
        } else {
             res = await this.$request.post('/search/analysis/keywords', {
                startDate,
                endDate,
                type: queryType,
                page: this.currentPage,
                pageSize: this.pageSize,
                searchQuery: this.searchQuery,
                sortProp: this.sortProp,
                sortOrder: this.sortOrder,
                windowDays
             }, { timeout: 120000, cancelToken });
        }

        const clientCostMs = Math.round(performance.now() - clientStartMs);
        const backendCostMs = res && res.costMs != null ? res.costMs : (res && res.meta && res.meta.costMs);
        const sqlCostMs = res && res.sqlCostMs != null ? res.sqlCostMs : (res && res.meta && res.meta.sqlCostMs);
        const earliestCostMs = res && res.meta && res.meta.earliestCostMs;
        const timingParts = [`前端 ${clientCostMs}ms`];
        if (backendCostMs != null) {
          timingParts.push(`后端 ${backendCostMs}ms`);
        }
        if (sqlCostMs != null) {
          timingParts.push(`SQL ${sqlCostMs}ms`);
        }
        if (earliestCostMs != null) {
          timingParts.push(`最早记录 ${earliestCostMs}ms`);
        }
        // fromAgg 在根上或 meta 里都认；命中预聚合表时文案写「命中预处理」
        const fromAgg = !!(res && (res.fromAgg || (res.meta && res.meta.fromAgg)));
        if (fromAgg) {
          timingParts.push('命中预处理');
        }
        this.lastQueryTimingText = timingParts.join(' · ');
        console.log('[搜索热词分析] 耗时', {
          tab: type,
          前端ms: clientCostMs,
          后端ms: backendCostMs,
          SQLms: sqlCostMs,
          最早记录ms: earliestCostMs,
          fromAgg,
          windowDays: res && res.windowDays,
          searchQuery: this.searchQuery
        });
        
        console.log('SearchKeywordAnalysis API Response:', res);

        if (res.code === 200) {
            let data = res.data;
            // Handle potential data wrapper (e.g., if backend returns { list: [...] })
            if (data && !Array.isArray(data) && Array.isArray(data.list)) {
                data = data.list;
            }
            
            if (type === 'new_keywords' && Array.isArray(data)) {
                const needFirstSeen = !!(res.needFirstSeen || (res.meta && res.meta.needFirstSeen));
                data = data.map(item => ({
                    ...item,
                    entrancesLabel: this.formatEntranceLabels(item.entrances),
                    firstSeen: needFirstSeen ? '加载中…' : this.formatShortDateTime(item.firstSeen)
                }));
            }

            this.materialCountMap = {};
            this.materialCountRowLoadingMap = {};
            this.resetMaterialCountBatchLoading();
            this.tableData = Array.isArray(data) ? Object.freeze(data) : [];
            // 不再查精确 total：本页满则允许翻下一页，未满则到末页
            const rowCount = this.tableData.length;
            const base = (this.currentPage - 1) * this.pageSize;
            this.total = rowCount < this.pageSize
              ? base + rowCount
              : base + rowCount + 1;
            
            console.log('Table Data Length:', this.tableData.length);
            
            if (type === 'new_keywords' && res.meta) {
                this.newKeywordsMeta = res.meta;
            }

            // 预聚合列表先出词，再二次请求补首次出现（两次普通 HTTP，不用长连接）
            if (type === 'new_keywords' && (res.needFirstSeen || (res.meta && res.meta.needFirstSeen))) {
              this.fillFirstSeenAsync(this.tableData, res.meta, this.entranceFilter);
            }
            
            this.$nextTick(() => {
                this.renderChart();
                this.updateTableLayoutWidth();
            });
        } else {
             this.$message.error(res.msg || '获取数据失败');
         }
         
       } catch (error) {
         // Request.js 错误拦截可能把 Cancel 转成字符串，需兼容判断
         if (axios.isCancel(error) || error === FETCH_CANCELLED_TIP || (error && error.message === FETCH_CANCELLED_TIP)) {
           return;
         }
         console.error(error);
         const errorMsg = error.response && error.response.data && error.response.data.msg 
             ? error.response.data.msg 
             : (error.message || error || '获取数据失败');
         this.$message.error('获取数据失败: ' + errorMsg);
       } finally {
        this.fetchCancelSource = null;
        this.tableLoading = false;
      }
    },
    
    renderChart() {
      const chartDom = document.getElementById('chart');
      if (!chartDom) return;
      
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
      this.chartInstance = echarts.init(chartDom);
      
      const top10 = this.tableData.slice(0, 10);
      
      const isNewKeywords = this.activeTab === 'new_keywords';
      const isWindowTrend = this.activeTab === 'window_trend';
      const valueField = isNewKeywords
        ? 'recentNum'
        : (isWindowTrend ? (this.sortProp || 'avg14') : 'totalNum');
      const nameField = 'searchName';
      const title = isNewKeywords
        ? 'Top 10 新增热词'
        : (isWindowTrend ? 'Top 10 窗口日均趋势' : `Top 10 搜索热词 (${this.resolveQueryType()})`);
      const valueName = isWindowTrend ? '日均搜索量' : '搜索次数';

      const option = {
        title: {
          text: title,
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            const item = top10[params[0].dataIndex];
            if (isNewKeywords) {
                return `${params[0].name}<br/>最近搜索: ${item.recentNum}<br/>历史搜索: ${item.historyNum}<br/>增长倍数: ${item.growthRate}`;
            }
            if (isWindowTrend) {
                return `${params[0].name}<br/>`
                  + WINDOW_TREND_AVG_COLUMNS.map(col => `${col.label}: ${this.formatAvg(item[col.prop])}`).join('<br/>');
            }
            return `${params[0].name}<br/>搜索次数: ${params[0].value}<br/>累计占比: ${parseFloat(item.percentile).toFixed(2)}%`;
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: top10.map(item => item[nameField]),
          axisLabel: {
            interval: 0,
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          name: valueName
        },
        series: [
          {
            name: valueName,
            type: 'bar',
            data: top10.map(item => item[valueField]),
            itemStyle: {
              color: isNewKeywords ? '#E6A23C' : (isWindowTrend ? '#67C23A' : '#409EFF')
            },
            label: {
              show: true,
              position: 'top',
              formatter: isWindowTrend ? (p) => this.formatAvg(p.value) : undefined
            }
          }
        ]
      };
      
      this.chartInstance.setOption(option);
    },
    
    exportData() {
      if (this.tableData.length === 0) {
        this.$message.warning('暂无数据可导出');
        return;
      }
      
      const isNewKeywords = this.activeTab === 'new_keywords';
      const isWindowTrend = this.activeTab === 'window_trend';
      
      let csvContent = "";
      const hasMaterialCount = Object.keys(this.materialCountMap).length > 0;
      if (isWindowTrend) {
          const avgHeaders = WINDOW_TREND_AVG_COLUMNS.map(col => col.label).join(',');
          csvContent = `排名,搜索词,${avgHeaders}\n`;
          this.tableData.forEach((row, index) => {
            const rank = (this.currentPage - 1) * this.pageSize + index + 1;
            const name = `"${String(row.searchName || '').replace(/"/g, '""')}"`;
            const avgs = WINDOW_TREND_AVG_COLUMNS.map(col => this.formatAvg(row[col.prop])).join(',');
            csvContent += `${rank},${name},${avgs}\n`;
          });
      } else if (isNewKeywords) {
          const materialCountHeader = hasMaterialCount ? ',贴图数量,模板数量,语音包数量' : '';
          csvContent = `排名,新增热词,入口类别,最近搜索,历史搜索,增长倍数,首次出现${materialCountHeader}\n`;
          this.tableData.forEach((row, index) => {
            const rank = (this.currentPage - 1) * this.pageSize + index + 1;
            const name = `"${row.searchName.replace(/"/g, '""')}"`;
            const entrances = `"${this.formatEntranceLabels(row.entrances).replace(/"/g, '""')}"`;
            const recent = row.recentNum;
            const history = row.historyNum;
            const rate = row.growthRate;
            const firstSeen = row.firstSeen;
            const counts = this.materialCountMap[row.searchName] || {};
            const materialCount = hasMaterialCount
              ? `,${counts[MATERIAL_COUNT_TYPE.TIETU] ?? ''},${counts[MATERIAL_COUNT_TYPE.TEMPLATE] ?? ''},${counts[MATERIAL_COUNT_TYPE.AUDIO] ?? ''}`
              : '';
            csvContent += `${rank},${name},${entrances},${recent},${history},${rate},${firstSeen}${materialCount}\n`;
          });
      } else {
          const materialCountHeader = hasMaterialCount ? ',素材数量' : '';
          csvContent = `排名,搜索词,搜索次数,累计占比(%)${materialCountHeader}\n`;
          this.tableData.forEach((row, index) => {
            const rank = (this.currentPage - 1) * this.pageSize + index + 1;
            const name = `"${row.searchName.replace(/"/g, '""')}"`;
            const count = row.totalNum;
            const percentile = row.percentile ? parseFloat(row.percentile).toFixed(2) : '0.00';
            const materialCount = hasMaterialCount ? `,${this.materialCountMap[row.searchName] ?? ''}` : '';
            csvContent += `${rank},${name},${count},${percentile}${materialCount}\n`;
          });
      }
      
      const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
      link.setAttribute("href", url);
      link.setAttribute("download", `搜索热词分析_${this.resolveQueryType()}_${timestamp}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
  padding: 10px 0;
  border-bottom: 1px solid #EBEEF5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.query-timing-text {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}
.box-card {
  margin: 20px;
}
.analysis-content {
  min-height: 520px;
}
.table-wrapper {
  width: 100%;
  overflow-x: auto;
}
.analysis-table /deep/ .el-table__header th .cell,
.analysis-table /deep/ .el-table__body td .cell {
  font-size: 20px;
}
.analysis-table /deep/ .el-button--mini {
  font-size: 17px;
  padding: 7px 12px;
}
.quick-search-cell {
  display: grid;
  grid-template-columns: repeat(3, auto);
  justify-content: center;
  align-items: center;
  gap: 6px 12px;
  padding: 6px 4px;
  box-sizing: border-box;
  white-space: normal;
  line-height: 1.4;
}
.analysis-action-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  line-height: 1.4;
}
.analysis-action-cell.is-row {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px 10px;
}
.quick-search-link {
  font-size: 17px;
  flex-shrink: 0;
  line-height: 1.4;
}
/* 仅压缩单元格左右空白，不改字号 */
.analysis-table.is-new-keywords /deep/ .el-table__header th .cell,
.analysis-table.is-new-keywords /deep/ .el-table__body td .cell {
  padding-left: 4px;
  padding-right: 4px;
}
.analysis-table.is-new-keywords /deep/ td.entrance-col .cell {
  white-space: normal;
  line-height: 1.35;
}
.entrance-label {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: normal;
  word-break: break-all;
  line-height: 1.35;
  text-align: center;
}
.search-name-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.material-count-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.4;
}
.material-ratio {
  margin-top: 4px;
  font-size: 20px;
  white-space: nowrap;
}
.trend-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;
  gap: 4px 0;
}
.trend-chart {
  width: 100%;
  height: 420px;
}
.related-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 8px;
  color: #606266;
  font-size: 14px;
}
.related-tip {
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f4f4f5;
  border-radius: 4px;
  color: #909399;
  font-size: 13px;
  line-height: 1.5;
}
/* 趋势日均方块：高度相对近28天 */
.is-window-trend .trend-bar-col .cell {
  padding: 4px 2px !important;
}
.trend-bar-cell {
  height: 68px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 2px 0 0;
}
.trend-bar-track {
  flex: 1;
  width: 56%;
  max-width: 28px;
  min-height: 40px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.trend-bar {
  width: 100%;
  border-radius: 3px 3px 1px 1px;
  background: #79bbff;
  min-height: 0;
  transition: height 0.15s ease;
}
.trend-bar-cell.is-pivot .trend-bar {
  background: #409eff;
}
.trend-bar-cell.is-pivot {
  box-shadow: inset 0 0 0 1px rgba(64, 158, 255, 0.35);
  border-radius: 2px;
}
.trend-bar-num {
  margin-top: 3px;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
  color: #303133;
}
</style>
